import { render } from "./OpinionScaleType.vue?vue&type=template&id=5c6d31bd"
import script from "./OpinionScaleType.vue?vue&type=script&lang=js"
export * from "./OpinionScaleType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__